<div [formGroup]="form" class="form-group form-group-date">
    <label 
        [for]="controlName"
        [ngClass]="{'is-invalid': isInvalid}"
        [class.field-invalid]="form.get(controlName)?.invalid && form.get(controlName)?.touched"
        [class.field-valid]="form.get(controlName)?.valid && form.get(controlName)?.touched && !isFocused(controlName)"
        [class.field-focused]="form.get(controlName)?.valid && isFocused(controlName)" 
        class="form-label">{{label}}</label>
    <input 
        (focus)="onFocus()"
        (blur)="onBlur()"
        (change)="onDateChange($event)"
        (keyup)="onKeyUp($event)"
        type="date"
        [id]="controlName"
        [formControlName]="controlName"
        [readonly]="isReadOnly"
        [min]="minDate"
        [max]="maxDate"
        class="form-control"
        [ngClass]="{'is-invalid': isInvalid, 'icono-placeholder-image': form.get(controlName)?.invalid && form.get(controlName)?.touched, 'text-invalid': form.get(controlName)?.invalid && form.get(controlName)?.touched}"
        [placeholder]="placeholder">
    
    <div *ngIf="form.get(controlName)?.invalid && form.get(controlName)?.touched" class="text-danger danger-text">
        <small *ngIf="isRequired" class="maxwithalert" style="font-size: 14px;">
            {{alertMessage}}
        </small>
        <small *ngIf="isFutureDate" class="maxwithalert" style="font-size: 14px;">
            {{alertMessage}}
        </small>
        <small *ngIf="isDateRangeError" class="maxwithalert" style="font-size: 14px;">
            La fecha debe estar entre {{minDate | date }} y {{maxDate | date}}.
        </small>
        <small *ngIf="isValidField(controlName) && !isRequired && !isFutureDate && !isDateRangeError" class="maxwithalert" style="font-size: 14px;">
            {{alertMessage}}
        </small>
    </div>
</div>